import { useAccessibleProject, useServiceAppState } from '@kc-console/context';

import type { ResponseCloudProject } from '@kc-console/context';

interface ProjectMenuStateProps {
  accessibleProjects: Array<ResponseCloudProject>;
  currentProject?: ResponseCloudProject;
}

/** 주석 작성
 * ~~~을 콘솔 레이아웃에 맞게 재정의하여 제공하는 훅입니다.
 * @description
 * -
 */
export const useRefinedProjectMenuState = (): ProjectMenuStateProps => {
  const { data = [] } = useAccessibleProject();
  const {
    state: { projectId },
  } = useServiceAppState();

  const currentProject = data?.find(project => project.id === projectId);

  return {
    currentProject,
    accessibleProjects: data,
  };
};
